import {
  SLIDE_THREE_DRAG_DROP,
  SLIDE_THREE_REMOVE_DROP,
  SLIDE_THREE_SET_AS_NEXT_STEP,
  SLIDE_THREE_APPLY_HINT,
} from '../Redux.constants';

export function slideThreeDragDrop(params) {
  return {
    type: SLIDE_THREE_DRAG_DROP,
    payload: params,
  };
}

export function slideThreeRemoveDrop(nodeId, groupId) {
  return {
    type: SLIDE_THREE_REMOVE_DROP,
    payload: {nodeId, groupId},
  };
}

export function slideThreeSetAsNextStep(optionID) {
  return {
    type: SLIDE_THREE_SET_AS_NEXT_STEP,
    payload: {optionID},
  };
}

export function slideThreeApplyHint() {
  return {
    type: SLIDE_THREE_APPLY_HINT,
    payload: {},
  };
}
